import { P, S, T } from '../../../styles/tokens';
import { Check } from './Icons';

interface ConsentRowProps {
  /** Whether this consent is checked. */
  checked: boolean;
  /** Toggle handler. */
  onToggle: () => void;
  /** Legal reference tag (e.g. "152-ФЗ"). */
  law: string;
  /** Consent description text. */
  text: string;
}

/** Checkable consent row with law badge. Mirrors pantene-flow.jsx ConsentRow (line 698).
 *  152-ФЗ compliance: each consent = separate unchecked checkbox. */
export function ConsentRow({ checked, onToggle, law, text }: ConsentRowProps) {
  return (
    <button
      onClick={onToggle}
      data-testid="consent-row"
      style={{
        display: 'flex',
        gap: 10,
        alignItems: 'flex-start',
        background: checked ? '#EFF7E9' : '#fff',
        borderRadius: 12,
        padding: 12,
        border: `1.5px solid ${checked ? 'rgba(45,138,78,0.30)' : P.line}`,
        cursor: 'pointer',
        textAlign: 'left' as const,
        width: '100%',
        fontFamily: T.fontBody,
        transition: 'all 0.2s ease',
      }}
    >
      {/* Checkbox */}
      <div
        style={{
          width: 22,
          height: 22,
          borderRadius: 6,
          flexShrink: 0,
          background: checked ? P.success : '#fff',
          border: `1.5px solid ${checked ? P.success : P.muted}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 1,
        }}
      >
        {checked && (
          <span style={{ color: '#fff', display: 'flex' }}>
            <Check size={14} />
          </span>
        )}
      </div>
      {/* Label + text */}
      <div style={{ flex: 1 }}>
        <div
          style={{
            font: T.caption,
            fontWeight: 700,
            color: checked ? P.success : P.muted,
            textTransform: 'uppercase' as const,
            letterSpacing: -0.08,
            marginBottom: 4,
          }}
        >
          {law}
        </div>
        <div style={{ font: T.footnote, color: S.label, lineHeight: 1.5 }}>{text}</div>
      </div>
    </button>
  );
}
